import React from 'react';
import classnames from 'classnames';
import SVG from 'react-inlinesvg';
import { LogoNames, LogoType } from '../../logos';

import styles from './logo.module.scss';

export type LogoProps = {
  name: LogoType;
  title?: string;
} & Pick<JSX.IntrinsicElements['svg'], 'className' | 'aria-label' | 'role' | 'aria-hidden'>;

export const Logo: React.FC<LogoProps> = ({ name, className, title, role, 'aria-label': ariaLabel }) => {
  const classes = classnames(styles.logo, className);

  return <SVG className={classes} title={title} role={role} src={LogoNames[name]} aria-label={ariaLabel} />;
};
